<template>
    <div class="Skeleton">
        <slot></slot>
    </div>
</template>
<script >
export default {
    name:"Skeleton",
    props:{
        bgColor:{
            type:String,
            default:"linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%)"
        }
    }
}
   
</script>
<style scoped>
.Skeleton{
    width: 100%;
    height: 300px;
    background:  v-bind(bgColor);
    border-radius: 25px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
    cursor: wait;
}
@keyframes shine {
    to {
      background-position-x: -200%;
    }
}
</style>